import React from 'react';
import PropTypes from 'prop-types';

export default function XSLTPageRedirect({ pageName, title, urlParams }) {
	let source = `./BenefitSolverView?page_name=${pageName}`;
	Object.getOwnPropertyNames(urlParams).forEach(key => {
		source += `&${key}=${urlParams[key]}`;
	});

	if (process.env.REACT_APP_MOCK_BACKEND === 'true') {
		return (
			<>
				<div className="page-title">
					<h2 className="page-header">{title}</h2>
				</div>
				<div>{source}</div>
			</>
		);
	}

	window.location.href = source;
	return null;
}

XSLTPageRedirect.propTypes = {
	pageName: PropTypes.string.isRequired,
	title: PropTypes.string,
	urlParams: PropTypes.object
};

XSLTPageRedirect.defaultProps = {
	urlParams: {}
};
